import localStorage from "legacy/utils/localStorage";

const LOCAL_STORAGE_KEY = "copied-control-flow-blocks";

export const clearCopiedBlocksFromLocalStorage = () => {
  localStorage.removeItem(LOCAL_STORAGE_KEY);
};
